// TennisTrack Hub — Form Nuovo/Modifica Atleta | 029 Project
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/api';
import Navbar from '../../components/Navbar';
import './Atleti.css';

const FormAtleta = () => {
  const { id } = useParams();
  const isModifica = Boolean(id);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nome: '', cognome: '', eta: '', altezzaCm: '', pesoKg: '',
    sport: 'tennis', livello: 'principiante', telefono: '', email: '', note: ''
  });
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState('');

  // Se modifica, carica dati atleta
  useEffect(() => {
    if (isModifica) {
      api.get(`/atleti/${id}`)
        .then(res => {
          const a = res.data.atleta;
          setForm({
            nome: a.nome || '', cognome: a.cognome || '',
            eta: a.eta || '', altezzaCm: a.altezza_cm || '',
            pesoKg: a.peso_kg || '', sport: a.sport || 'tennis',
            livello: a.livello || 'principiante', telefono: a.telefono || '',
            email: a.email || '', note: a.note || ''
          });
        })
        .catch(() => navigate('/atleti'));
    }
  }, [id, isModifica, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrore('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome.trim() || !form.cognome.trim()) {
      return setErrore('Nome e cognome sono obbligatori.');
    }
    setLoading(true);
    try {
      if (isModifica) {
        await api.put(`/atleti/${id}`, form);
        navigate(`/atleti/${id}`);
      } else {
        const res = await api.post('/atleti', form);
        navigate(`/atleti/${res.data.atleta.id}`);
      }
    } catch (err) {
      setErrore(err.response?.data?.error || 'Errore durante il salvataggio.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-layout">
      <Navbar />
      <main className="page-main">

        <div className="page-header">
          <div>
            <h1>{isModifica ? 'Modifica atleta' : 'Nuovo atleta'}</h1>
            <p>{isModifica ? 'Aggiorna i dati dell\'atleta' : 'Inserisci i dati del nuovo atleta'}</p>
          </div>
          <button className="btn btn-secondary" onClick={() => navigate('/atleti')}>
            ← Indietro
          </button>
        </div>

        <div className="card form-card">
          {errore && <div className="alert alert-error">{errore}</div>}

          <form onSubmit={handleSubmit}>
            {/* Nome e Cognome */}
            <div className="form-row">
              <div className="form-group">
                <label>Nome *</label>
                <input type="text" name="nome" value={form.nome} onChange={handleChange} placeholder="Mario" required />
              </div>
              <div className="form-group">
                <label>Cognome *</label>
                <input type="text" name="cognome" value={form.cognome} onChange={handleChange} placeholder="Rossi" required />
              </div>
            </div>

            {/* Dati fisici */}
            <div className="form-row form-row-3">
              <div className="form-group">
                <label>Età</label>
                <input type="number" name="eta" value={form.eta} onChange={handleChange} placeholder="25" min="1" max="100" />
              </div>
              <div className="form-group">
                <label>Altezza (cm)</label>
                <input type="number" name="altezzaCm" value={form.altezzaCm} onChange={handleChange} placeholder="175" min="50" max="250" />
              </div>
              <div className="form-group">
                <label>Peso (kg)</label>
                <input type="number" name="pesoKg" value={form.pesoKg} onChange={handleChange} placeholder="70" min="20" max="300" step="0.1" />
              </div>
            </div>

            {/* Sport e livello */}
            <div className="form-row">
              <div className="form-group">
                <label>Sport *</label>
                <select name="sport" value={form.sport} onChange={handleChange}>
                  <option value="tennis">🎾 Tennis</option>
                  <option value="fitness">💪 Fitness</option>
                  <option value="altro">🏅 Altro</option>
                </select>
              </div>
              <div className="form-group">
                <label>Livello *</label>
                <select name="livello" value={form.livello} onChange={handleChange}>
                  <option value="principiante">Principiante</option>
                  <option value="intermedio">Intermedio</option>
                  <option value="avanzato">Avanzato</option>
                </select>
              </div>
            </div>

            {/* Contatti */}
            <div className="form-row">
              <div className="form-group">
                <label>Telefono</label>
                <input type="tel" name="telefono" value={form.telefono} onChange={handleChange} placeholder="+39 333 1234567" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="atleta@esempio.com" />
              </div>
            </div>

            {/* Note */}
            <div className="form-group">
              <label>Note</label>
              <textarea name="note" value={form.note} onChange={handleChange} placeholder="Note aggiuntive sull'atleta..." rows={3} />
            </div>

            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/atleti')}>
                Annulla
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Salvataggio...' : isModifica ? 'Salva modifiche' : 'Crea atleta'}
              </button>
            </div>
          </form>
        </div>

      </main>
    </div>
  );
};

export default FormAtleta;
